// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2FF8X","row":"ProcedureTreatmentSummary_row__31Z2P"};